import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({ name: "weekOf" })
export class WeekOfPipe implements PipeTransform {
  transform(value: Date): string {
    return moment(value).week().toString();
  }
}
